module.exports = __webpack_public_path__ + "assets/img/title.25327499.png";